export default "__VITE_ASSET__D63yhBC0__"